import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import { S_Btn_Search, S_Select, S_Title } from '~/components/SearchItem';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { T_TableRow, T_TitleCell } from '~/components/TableItem';
import SearchBar from '~/components/SearchBar';
import SortableTable from './SortableTable';
import SimpleSortableTable from './SimpleSortableTable';

// const list = [
//   { a: '打樁船', b: '船1', c: 'Ａ', d: '111/01/01-111/10/31', e: '111/06/10-111/11/02', f: '否', g: '', h: '是' },
//   { a: '打樁船', b: '船2', c: 'B', d: '111/05/01-111/12/31', e: '111/06/10-111/11/02', f: '否', g: '', h: '是' },
//   { a: '海纜鋪設船', b: '', c: 'B', d: '110/01/01-111/07/01', e: '111/06/10-111/11/02', f: '是(後)(接d)', g: '', h: '否' },
//   { a: '海纜鋪設船', b: '', c: 'B', d: '111/01/01-111/10/31', e: '111/06/10-111/11/02', f: '是(後)(接d)', g: '', h: '否' },
//   { a: '海纜鋪設船', b: '', c: 'B', d: '111/01/01-111/10/31', e: '111/06/10-111/11/02', f: '是(後)(接d)', g: '', h: '否' },
//   { a: '海纜鋪設船', b: '船1', c: 'D', d: '111/01/01-111/10/31', e: '111/06/10-111/11/02', f: '否', g: '', h: '否' },
//   { a: '海纜鋪設船', b: '船2', c: 'D', d: '111/01/01-111/10/31', e: '111/06/10-111/11/02', f: '否', g: '', h: '否' },
//   { a: '海纜鋪設船', b: '船3', c: 'D', d: '111/01/01-111/10/31', e: '111/06/10-111/11/02', f: '否', g: '', h: '否' },

// ];

const RenderTableTitle = () => {
  const ary = [
    { name: '工作種類' },
    { name: '船名' },
    { name: '使用風場' },
    { name: '船舶許可期間' },
    { name: '預定使用期間' },
    // { name: '是否有風場先後承接問題' },
    { name: '實際抵台時間' },
    { name: '是否抵台' },
  ];
  return (
    <TableHead>
      <TableRow style={{ height: 48 }}>
        {ary.map((o, i) => (
          <T_TitleCell
            key={i}
            text={o.name}
          />
        ))}
      </TableRow>
    </TableHead>
  );
};

const RenderTableBody = () => {
  const list = useSelector(state => state.data.WindsBoatList || []);
  const cellStyle = { fontSize: 14 };

  return (
    <TableBody>
      {list.map((o, i) => (
        <T_TableRow key={i}>
          <TableCell align='center' style={cellStyle}>{o.job}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.ship_name}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.windfield_simplename}</TableCell>
          <TableCell align='center' style={cellStyle}>
            <div>
              {o.license_period_list.map((o2, i2) => <div key={i2}>{o2}</div>)}
            </div>
          </TableCell>
          <TableCell align='center' style={{ ...cellStyle, backgroundColor: o.overlap_color }}>
            <div>
              {o.scheduled_period_list.map((o2, i2) => <div key={i2}>{o2}</div>)}
            </div>
          </TableCell>
          {/* <TableCell align='center' style={cellStyle}>{o.ording_issue}</TableCell> */}
          <TableCell align='center' style={cellStyle}>{o.actural_taiwan_date}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.arrive_in_tw}</TableCell>
        </T_TableRow>
      ))}
    </TableBody>
  );
};

const RenderTable = () => {
  const list = useSelector(state => state.data.WindsBoatList || []);
  const haveData = list.length > 0;
  return (
    <TableContainer>
      <Table style={{ backgroundColor: 'white', borderRadius: 8 }}>
        <RenderTableTitle />
        {haveData && <RenderTableBody />}
      </Table>
    </TableContainer>
  );
};

const App = () => {
  const dispatch = useDispatch();
  const list = useSelector(state => state.data.WindsBoatList || []);
  const names = useSelector(state => state.data.AllFieldsShipNameList || []);
  const jobs = useSelector(state => state.data.AllFieldsJobs || []);

  useEffect(() => {
    Actions_Wind.Gis.getAllFieldsShipNameList(dispatch);
  }, []);
  
  useEffect(() => {
    Actions_Wind.Gis.getAllFieldsJobs(dispatch);
  }, []);

  // console.log('names', names);
  // console.log('jobs', jobs);
  // console.log('list', list);
  const haveData = list.length > 0;
  return (
    <SearchBar style={{ marginTop: 16, marginBottom: 25 }} text='船舶資訊' defaultOpen>
      <div style={{ marginLeft: 52, marginRight: 52, marginBottom: 20 }}>
        <div style={{ borderRadius: 8, boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)' }}>
          {/* <RenderTable /> */}
          {/* <SortableTable data={list} /> */}
          <SimpleSortableTable />
          {/* <SimpleSortableTable ships={names.filter(x => x !== '')} jobs={jobs.filter(x => x !== '')} /> */}

          {/* {haveData && this.renderTableBar()} */}
        </div>
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
      </div>
    </SearchBar>
  );
};

export default App;
